export default function initQuformValidation() {
    const $ = jQuery;

    $('.quform-form-1').on('quform:errorEnd', function (e, form) {
        // エラー表示後の処理
        const firstError = $(this).find('.quform-has-error').first()[0];
        const firstErrorScrollTop = firstError.getBoundingClientRect().top + window.scrollY;
        const headerHeight = document.querySelector('.l-header').offsetHeight;
        console.log(headerHeight)

        window.scrollTo({
            top: firstErrorScrollTop - headerHeight,
            behavior: 'smooth'
        });
    });
}